<template>
  <v-app id="inspire">
    <div v-show="loading">
      <div v-bind:class="{ loaded:loadFlg }">
        <div id="loading-animation" class="loading-animation">
          <i class="loading-animation_line"></i>
        </div>
      </div>
    </div>

    <div v-show="!loading">
      <frame/>
      <v-content class="footSpace">
        <transition name="slide-fade">
          <router-view/>
        </transition>
      </v-content>
      <player/>
      <snack-bar></snack-bar>
      <AlertCoverNotLandScape/>
    </div>
  </v-app>
</template>

<script>
import Frame from '@/components/Frame.vue'
import Player from '@/components/Player.vue'
import SnackBar from '@/components/SnackBar.vue'
import AlertCoverNotLandScape from '@/components/atoms/AlertCoverNotLandScape'

export default {
  name: 'HomeIndex',
  components: {
    AlertCoverNotLandScape,
    Frame,
    Player,
    SnackBar
  },
  data () {
    return {
      loading: true,
      loadFlg: false,
      isLandscape: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.loadFlg = true
    }, 2500)
    setTimeout(() => {
      this.loading = false
    }, 3100)
  }
}
</script>

<style>
  /********************
  loading effects
  ********************/
  .loading-animation{
    position: fixed;
    z-index: 100;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .loading-animation:before,
  .loading-animation:after{
    line-height: 1;
    position: fixed;
    z-index: 99;
    right: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 50%;
    margin-right: auto;
    margin-left: auto;
    content: ' ';
    transition: all .3s cubic-bezier(.785, .135, .15, .86) 0s;
    transition-delay: .3s;
    background-color: #15c06a;
  }
  .loading-animation:before{
    top: 0;
  }
  .loading-animation:after{
    bottom: 0;
  }
  .loaded .loading-animation:before{
    height: 0;
    -webkit-transform: translateY(-1%);
    -ms-transform: translateY(-1%);
    transform: translateY(-1%);
  }
  .loaded .loading-animation:after{
    height: 0;
    -webkit-transform: translateY(1%);
    -ms-transform: translateY(1%);
    transform: translateY(1%);
  }

  .loading-animation_line{
    line-height: 1;
    position: fixed;
    z-index: 100;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: inline-block;
    overflow: hidden;
    width: 150px;
    height: 1.25em;
    margin: auto;
    transition: all .3s cubic-bezier(.785, .135, .15, .86) 0s;
    transition-delay: .6s;
    text-align: center;
  }
  .loading-animation_line:after{
    position: absolute;
    z-index: 100;
    top: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 0;
    height: 100%;
    margin: auto  auto auto 0;
    content: ' ';
    -webkit-animation: loading-animation 2s ease-in-out .1s infinite normal backwards;
    animation: loading-animation 2s ease-in-out .1s infinite normal backwards;
    background-color: #fff;
    will-change: transform, width;
  }
  .loading-animation_line:before{
    font-family: 'Poppins', sans-serif;
    font-size: 1.25em;
    font-weight: bold;
    font-style: normal;
    line-height: 1;
    display: block;
    content: 'LOADING';
    -webkit-animation: loading-animation_text 1s ease .1s infinite alternate both;
    animation: loading-animation_text 1s ease .1s infinite alternate both;
    letter-spacing: .5em;
    color: #fff;
    will-change: opacity;
  }
  .loaded .loading-animation_line{
    overflow: hidden;
    height: 0;
  }
  .loaded .loading-animation_line:after,
  .loaded .loading-animation_line:before{
    -webkit-animation: none;
    animation: none;
  }
  .loaded .loading-animation_line:before{
    content: 'LOADED!';
  }
  /********************
  animation setting
  ********************/
  @-webkit-keyframes loading-animation{
    0%{
      width: 0;
    }
    100%{
      width: 100%;
      -webkit-transform: translate(100%);
      transform: translate(100%);
    }
  }
  @keyframes loading-animation{
    0%{
      width: 0;
    }
    100%{
      width: 100%;
      -webkit-transform: translate(100%);
      transform: translate(100%);
    }
  }
  @-webkit-keyframes loading-animation_text{
    0%{
      opacity: 1;
      color: #cba166;
    }
    50%{
      color: #333;

    }
    100%{
      opacity: .5;
      color: #fff;
    }
  }
  @keyframes loading-animation_text{
    0%{
      opacity: 1;
      color: #cba166;
    }
    50%{
      color: #333;
    }
    100%{
      opacity: .5;
      color: #fff;
    }
  }

  .slide-fade-enter-active {
    transition: all 2s ease;
  }
  .slide-fade-leave-active {
    transition: all 2s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to{
    transform: translateX(100px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/HomeIndex.vue